import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import GenericTable from '../tables/GenericTable';
import { formatDate } from '../../utils/formatDate';
import styles from '../../styles/personal-survey.module.scss';

const READ_COLUMNS = [
  { key: 'info', label: '' },
  { key: 'value', label: '' },
];

const LegacySurveyPanel = ({ legacy }) => {
  if (!legacy) return null;

  const rows = Object.entries(legacy.data || {})
    .filter(([, value]) => value != null && value !== '')
    .map(([key, value]) => ({ info: key, value: String(value) }));

  return (
    <div className={styles.legacy}>
      <Collapse
        items={[
          {
            key: 'legacy',
            label: `Podaci pre migracije (arhiva) - migrirano ${formatDate(legacy.migratedAt)}`,
            children: (
              <>
                <div className={styles.legacy__note}>
                  Ovi podaci potiču iz prethodne verzije ankete i prikazani su samo informativno. Nisu deo trenutne ankete i ne mogu se menjati.
                </div>
                <GenericTable data={rows} columns={READ_COLUMNS} grayTheme mobNoScroll />
              </>
            ),
          },
        ]}
      />
    </div>
  );
};

LegacySurveyPanel.propTypes = {
  legacy: PropTypes.shape({
    data: PropTypes.object,
    migratedAt: PropTypes.string,
  }),
};

export default LegacySurveyPanel;
